// ============================================
// Creator State - Example Dialogues (Zustand 기반)
// ============================================

import { useCreatorStore } from '../../../stores/creatorStore.js';

// Getters
export const getExampleDialogues = () => useCreatorStore.getState().exampleDialogues;
export const getCurrentExampleType = () => useCreatorStore.getState().currentExampleType;
export const getEditingExampleIndex = () => useCreatorStore.getState().editingExampleIndex;

// Setters
export function setExampleDialogues(dialogues) {
  useCreatorStore.getState().setExampleDialogues(dialogues);
}

export function addExampleDialogue(dialogue) {
  useCreatorStore.getState().addExampleDialogue(dialogue);
}

export function updateExampleDialogue(index, dialogue) {
  useCreatorStore.getState().updateExampleDialogue(index, dialogue);
}

export function removeExampleDialogue(index) {
  useCreatorStore.getState().removeExampleDialogue(index);
}

export function setCurrentExampleType(type) {
  useCreatorStore.getState().setCurrentExampleType(type);
}

export function setEditingExampleIndex(index) {
  useCreatorStore.getState().setEditingExampleIndex(index);
}
